const API_BASE = process.env.REACT_APP_API_BASE || (typeof window !== 'undefined' && window.__API_BASE__) || '/api';

export default API_BASE;
